import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosConfig from '../../utils/axiosConfig';
import { mongoIdToString } from '../../utils';

const currentProfileId = (getState) => mongoIdToString(getState().profile.currentProfile?._id);

export const getTransactionList = createAsyncThunk('wallet/transaction/list', async (global = false, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post('/wallet/transaction/list', {
			profile: currentProfileId(getState),
			global: global 
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getWalletStats = createAsyncThunk('wallet/stats', async (global = false, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post('/wallet/stats', {
			profile: currentProfileId(getState),
			role: getState().profile.currentProfile.role,
			global: global
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const addWithdrawRequet = createAsyncThunk('wallet/withdraw/request', async ({amount, email}, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post('/wallet/withdraw/request', {
			tutor: currentProfileId(getState),
			amount: amount,
			email: email
		});

		return response.data
	} catch (error) {
		console.log(error)
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getWithdrawList = createAsyncThunk('wallet/withdraw/list', async (global = false, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post('/wallet/withdraw/list', {
			tutor: currentProfileId(getState),
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const getAllWithdraw = createAsyncThunk('wallet/withdraw/all', async (global = false, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post('/wallet/withdraw/all', {
			profile: currentProfileId(getState),
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const acceptWithdraw = createAsyncThunk('wallet/withdraw/accept', async (id, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post('/wallet/withdraw/accept', {
			profile: currentProfileId(getState),
			id: id
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});

export const rejectWithdraw = createAsyncThunk('wallet/withdraw/reject', async (id, { rejectWithValue, getState }) => {
	try {
		const response = await axiosConfig.post('/wallet/withdraw/reject', {
			profile: currentProfileId(getState),
			id: id
		});

		return response.data
	} catch (error) {
		return rejectWithValue({
			error: error.response.data ? error.response.data.message : error.message
		});
	}
});
